import { instanceHref } from "@/lib/instance";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { isEntityLink } from "./editor/entityLinkNavigation";
import { remarkContinuousLists } from "@/lib/listNumbering";

export { MarkdownEditor, type MarkdownEditorHandle } from "./editor/MarkdownEditor";

/** Read-only Markdown (issue descriptions, comments, project description). */
export function Markdown({ source, className = "" }: { source: string; className?: string }) {
  if (!source.trim()) return null;
  return (
    <div className={`prose-tern ${className}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkContinuousLists]} components={{
        img: ({ src, alt, title }) => title === "tern-video"
          ? <video src={src ? instanceHref(src) : src} aria-label={alt} controls preload="metadata" onClick={(event) => event.stopPropagation()} />
          : <img src={src ? instanceHref(src) : src} alt={alt} title={title} loading="lazy" />,
        a: ({ href, children }) => <a href={href ? instanceHref(href) : href} onClick={(event) => event.stopPropagation()} {...(href && isEntityLink(href, location.origin) ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...(href?.startsWith("/api/attachments/") ? { className: "tern-attachment", download: true } : {})}>{children}</a>,
      }}>{source}</ReactMarkdown>
    </div>
  );
}
